<template>
  <div class="VisaFinal">
    <div class="cart-products">
      <section id="servicios" class="seccion-gris">
        <div id="etapas-compra">
          <div class="etapas-compra-hitos">
            <router-link :to="'/carrito'" class="hito-inactivo">Carro de compras</router-link>
            <router-link :to="'/datos-compra'" class="hito-inactivo"
              >Datos para la compra</router-link
            >
            <router-link :to="'/resumen'" class="hito-activo">Finalizar Compra</router-link>
          </div>
        </div>

        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-sm-12">
              <template v-if="mensaje == ''">
                <template v-if="!loading"> </template>
                <template v-else-if="loading == true">
                  <li class="list-group-item">
                    <i class="fa fa-refresh fa-spin fa-3x fa-fw fa-mrbig"></i>
                    <p>Estamos procesando su compra. Por favor, espere.</p>
                  </li>
                </template>
              </template>

              <div :class="[mensaje === '' ? 'd-none' : 'alert alert-success']" role="alert">
                <button type="button" class="close" data-dismiss="alert" @click="ocultar()">
                  &times;</button
                ><strong>{{ mensaje }}<router-link to="/pedidos">aquí</router-link>.</strong>
              </div>
              <div :class="[mensaje_error === '' ? 'd-none' : 'alert alert-danger']" role="alert">
                <button type="button" class="close" data-dismiss="alert" @click="ocultar()">
                  &times;</button
                ><strong><span v-html="mensaje_error"></span></strong>
              </div>

              <template v-if="fail_payment_card">
                <h4>Detalles del pedido rechazado</h4>
                <div class="row">
                  <div class="col-lg-6">
                    <ul class="list-group mb-3">
                      <li class="list-group-item" v-for="(item, index) in cartProducts" :key="index">
                        <div class="row">
                          <template v-if="item.subproduct.id_lote == 0">
                            <div class="col-6 col-sm-4 margen-automatico" style="text-align: left;">
                              <p>
                                <strong>{{ item.name_product_es }}</strong>
                              </p>
                            </div>
                          </template>
                          <template v-else>
                            <div class="col-6 col-sm-4 margen-automatico" style="text-align: left;">
                              <p>
                                <strong>{{
                                  item.name_product_es + ' Lote: ' + item.subproduct.lote_sku
                                }}</strong>
                              </p>
                            </div>
                          </template>

                          <div class="col-6 col-sm-4 margen-automatico">
                            <p>
                              {{ item.price_product | currency }} X
                              <span class="span-cantidad-calculator"
                                ><strong>{{ item.qty }} </strong></span
                              >
                            </p>
                          </div>
                          <div class="col-12 col-sm-4 margen-automatico" style="text-align: left;">
                            <p>
                              <strong>{{ (item.price_product * item.qty) | currency }}*</strong>
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <small>*Los precios incluyen IGV</small>
                    <hr />
                  </div>
                  <div class="col-lg-6">
                    <ul class="list-group mb-3">
                      <li class="list-group-item d-flex justify-content-between">
                        <span>Subtotal:</span>
                        {{ (totalValue - delivery_detail.delivery_cost) | currency }}
                      </li>
                      <li class="list-group-item d-flex justify-content-between">
                        <span>Despacho:</span> {{ delivery_detail.delivery_cost | currency }}
                      </li>

                      <li class="list-group-item d-flex justify-content-between">
                        <span><strong>Total:</strong></span>
                        <strong>{{ totalValue | currency }}</strong>
                      </li>
                    </ul>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </section>
      <TwoModules></TwoModules>
      <News></News>
    </div>
  </div>
</template>

<script>
import TwoModules from '@/components/products/TwoModules.vue';
import News from '@/components/products/Guia.vue';
import axios from 'axios';
import { config_settings } from '../../../../config.js';
import { mapState, mapActions, mapMutations } from 'vuex';
import {
  errorToaster,
  infoToaster,
  successToaster,
} from '../../../../components/shared/service/ErrorHandler.js';

//HTTP ERROR STATUS
const NOT_FOUND = 404;
const BAD_REQUEST = 400;
const UNAUTHORIZED = 401;
const CONFLICT = 409;
const INTERNAL_SERVER_ERROR = 500;
const BAD_GATEWAY = 502;

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    console.log(error);
    if (error.message === 'Network Error') {
      toastr.error(
        'No se puede conectar con el servidor. Verifique su conexión a internet',
        'ERROR',
        { iconClass: 'customer-danger' },
      );
    } else if (error.response.status === UNAUTHORIZED) {
      if (error.response.data.message === 'Access is denied') {
        toastr.error('Usted no tiene los provilegios para acceder a esta sección', 'ERROR', {
          iconClass: 'customer-danger',
        });
      } else {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  },
);

export default {
  name: 'Cart',
  components: { TwoModules, News },
  data() {
    return {
      token_transaction: this.$route.params.token,
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
      token: localStorage.getItem('access_token'),
      refresh_token: localStorage.getItem('refresh_token'),
      id_delivery: localStorage.getItem('id_delivery'),
      day_delivery: localStorage.getItem('day_delivery'),
      ruc_agency: localStorage.getItem('ruc_agency'),
      dir_agency: localStorage.getItem('dir_agency'),
      cdp_data: JSON.parse(localStorage.getItem('cdp_details_for_visanet')),
      niubizSecurityToken: localStorage.getItem('niubizSecurityToken'),
      address_details: JSON.parse(localStorage.getItem('address_details')),
      totalValue: 0.0,
      products_data: [],
      client_email: '',
      client_username: '',
      client_name: '',
      client_lastname: '',
      client_dni: '',
      cliente_phone: '',
      cboDepartamento: '',
      cboProvincia: '',
      cboDistrito: '',
      client_address: '',
      cboDepartamento: '',
      tipoCDP: '0',
      razsoc: '',
      facdir: '',
      ruc: '',
      delivery_detail: '',
      gen_delivery_cost: 0.0,
      mensaje: '',
      mensaje_error: '',
      json_cliente: '',
      loading: false,
      userdata: false,
      fail_payment_card: false,
    };
  },
  computed: mapState(['cartProducts']),
  methods: {
    /* Resetting the store and localstorage after removing product from cart */
    ...mapMutations(['SET_CART_PRODUCTS']),
    scroll_inicio() {
      window.scrollTo(0, 0);
      console.log('CDP DATA: ' + JSON.stringify(this.cdp_data));
    },

    refreshToken() {
      var refresh_token = localStorage.getItem('refresh_token');
      var refresh_credentials = new FormData();
      refresh_credentials.append('grant_type', 'refresh_token');
      refresh_credentials.append('refresh_token', refresh_token);
      refresh_credentials.append('id_store', config_settings.STORE);

      const refreshingCall = axios({
        method: 'post',
        url: config_settings.AUTH_SERVER_URL + '/oauth/token',
        data: refresh_credentials,
        withCredentials: true,
        auth: {
          username: 'USER_CLIENT_APP',
          password: 'password',
        },
      }).then((response) => {
        localStorage.setItem('access_token', response.data.access_token);
        localStorage.setItem('refresh_token', response.data.refresh_token);
        return Promise.resolve(true);
      });
      return refreshingCall;
    },

    get_puser_data() {
      this.userdata = false;
      axios({
        method: 'get',
        url: config_settings.RESOURCE_SERVER_URL + '/GET/profile',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          console.log('responde todo');

          this.userdata = true;
          this.client_email = response.data.email_client;
          this.client_username = response.data.nick_client;
          this.client_name = response.data.name_client;
          this.client_lastname = response.data.surname_client;
          this.client_dni = response.data.dni_client;
          this.cliente_phone = response.data.phone_client;
          this.client_address = response.data.address_client;

          var cboDistrito = response.data.id_district.id_district;
          if (cboDistrito != 0) {
            this.cboDistrito = response.data.id_district.id_district;
          } else {
            this.cboDistrito = '';
          }
          console.log('responde todo' + this.userdata);
          this.json_cliente = response.data;
          console.log('DATOS CLIENTE' + JSON.stringify(this.json_cliente));

          //realizar el pedido

          this.get_delivery_detail();
          this.analizeCart();
          this.generate_charge();
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.get_puser_data();
              })
              .catch((_) => {
                this.userdata = false;
              });
          } else {
            this.userdata = false;
            toastr.error(error.response.data.details, error.response.data.message, {
              iconClass: 'customer-danger',
            });
          }
        });
    },

    ocultar() {
      this.mensaje = '';
      this.mensaje_error = '';
    },

    removeAllProductCart() {
      var products = [];
      this.SET_CART_PRODUCTS(products);
      localStorage.setItem('iki-cart', JSON.stringify(products));
      this.analizeCart();
    },

    generate_charge() {
      console.log('SI LLEGO HASTA AQUI');
      console.log(JSON.stringify(this.address_details));

      if (this.cdp_data.factura) {
        this.tipoCDP = 2;

        this.ruc = this.cdp_data.ruc;
        this.razsoc = this.cdp_data.companyName;
        this.facdir = this.cdp_data.billing_address;
      } else {
        this.tipoCDP = 1;
      }

      this.loading = true;

      this.cartProducts.forEach((product, index) => {
        this.products_data[index] = {
          code_product: product.code_product,
          quantity: product.qty,
          cod_sub_product: product.subproduct.id_lote,
        };
      });

      var json_data = '';

      var myDate = new Date(this.day_delivery);
      var dia = myDate.getDay();
      //Date.parseDate(this.day_delivery, "d");
      console.log('DAAAAAA; ' + dia);

      if (this.tipoCDP == 1) {
        json_data = {
          tokenID: this.token_transaction,
          securityToken: this.niubizSecurityToken,
          email: this.client_email,
          sales_detail: this.products_data,
          factura: false,
          detalle_despacho: {
            id_despacho: { id_delivery: this.id_delivery },
            cod_ubigeo: !this.address_details
              ? ''
              : this.address_details.id_district.cod_ubigeo,
            detalle_ubicacion: !this.address_details
              ? ''
              : this.address_details.address +
                ', ' +
                this.address_details.id_district.desc_district +
                ', ' +
                this.address_details.id_district.province.desc_province +
                ', ' +
                this.address_details.id_district.province.departament.desc_departament,
            dia_entrega: this.day_delivery,
            cod_erp_direccion: !this.address_details ? '' : this.address_details.cod_erp,
            transport_company: this.ruc_agency,
            transport_company_address: this.dir_agency,
            cod_ubigeo_transport_company:
              this.dir_agency === '' ? '' : this.transport_address_details.id_district.cod_ubigeo,
          },
        };

        /*
        var json_erp = {
          "id": this.json_cliente.dni_client, 
          "nombre": this.json_cliente.surname_client + " " + this.json_cliente.name_client,
          "evento": "N",
          "direccion": this.json_cliente.address_client,
          "tipo_Documento": 1,
          "moneda": "SOL",
          "email": this.json_cliente.email_client,
          "telefono": this.json_cliente.phone_client,
          "codigo_Vendedor": "151",
          "codigo_Cobrador": "90",
          "codigo_Sectorista": "BAGUILAR",
          "direccion_Embarque": this.address_details.cod_erp,
          "ubigeo": this.address_details.id_district.cod_ubigeo == null? "" : this.address_details.id_district.cod_ubigeo,
          }
          this.createAccount_erp(json_erp);
          */
      } else if (this.tipoCDP == 2) {
        json_data = {
          tokenID: this.token_transaction,
          securityToken: this.niubizSecurityToken,
          email: this.client_email,
          sales_detail: this.products_data,
          factura: true,
          ruc: this.ruc,
          companyName: this.razsoc,
          billing_address: this.facdir,
          detalle_despacho: {
            id_despacho: { id_delivery: this.id_delivery },
            cod_ubigeo:
              this.address_details.id_district.cod_ubigeo == null
                ? ''
                : this.address_details.id_district.cod_ubigeo,
            detalle_ubicacion:
              this.address_details.address +
              ', ' +
              this.address_details.id_district.desc_district +
              ', ' +
              this.address_details.id_district.province.desc_province +
              ', ' +
              this.address_details.id_district.province.departament.desc_departament,
            dia_entrega: this.day_delivery,
            cod_erp_direccion: this.address_details.cod_erp,
            transport_company: this.ruc_agency,
            transport_company_address: this.dir_agency,
            cod_ubigeo_transport_company:
              this.dir_agency == '' ? '' : this.transport_address_details.id_district.cod_ubigeo,
          },
        };

        /*
        var json_erp = {
          "id": this.ruc, 
          "nombre": this.razsoc,
          "evento": "N",
          "direccion": this.json_cliente.address_client,
          "tipo_Documento": 6,
          "moneda": "SOL",
          "email": this.json_cliente.email_client,
          "telefono": this.json_cliente.phone_client,
          "codigo_Vendedor": "151",
          "codigo_Cobrador": "90",
          "codigo_Sectorista": "BAGUILAR",
          "direccion_Embarque": this.address_details.cod_erp,
          "ubigeo": this.address_details.id_district.cod_ubigeo == null? "" : this.address_details.id_district.cod_ubigeo,
          }
          this.createAccount_erp(json_erp);
          */
      }

      console.log('ESTE ES EL JSON DATA A NIUBIZ: ' + JSON.stringify(json_data));

      axios({
        method: 'post',
        url: config_settings.RESOURCE_SERVER_URL + '/POST/cdp-visanet',
        data: json_data,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        },
      })
        .then((response) => {
          console.log(response.data);
          this.token_transaction = '';
          localStorage.setItem('niubizSecurityToken', '');
          this.loading = false;
          this.removeAllProductCart();
          this.mensaje =
            'Su compra fue efectuada correctamente, se le enviarán los detalles y el cargo a su correo electrónico. Tambien puede revisar el detalle de sus compras y pedidos ';
          this.mensaje_error = '';
        })
        .catch((error) => {
          this.token_transaction = '';
          localStorage.setItem('niubizSecurityToken', '');
          this.loading = false;

          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.generate_charge();
              })
              .catch((_) => {
                toastr.error('Debe iniciar sesión antes de continuar', 'Error', {
                  iconClass: 'customer-danger',
                });
                this.mensaje_error = 'Debe iniciar sesión antes de continuar';
                this.mensaje = '';
                this.$router.push({ path: '../../login/' });
              });
          } else if (error.response.status === BAD_REQUEST) {
            var hoy = new Date();
            var fecha = hoy.getDate() + '/' + (hoy.getMonth() + 1) + '/' + hoy.getFullYear();
            var hora = hoy.getHours() + ':' + hoy.getMinutes();
            var FechaYhora = fecha + ' ' + hora;
            console.log(error.response.data.details);

            //this.removeAllProductCart();
            this.fail_payment_card = true;
            this.mensaje = '';
            this.mensaje_error =
              'ERROR: Su tarjeta o alguno de los datos ingresados ha sido rechazado. Por favor inténtelo nuevamente. Fecha: ' +
              FechaYhora;
          } else if (error.response.status === BAD_GATEWAY) {
            console.log(error.response.data.details);

            this.removeAllProductCart();
            this.mensaje =
              'Su compra fue efectuada correctamente, sin embargo, es posible que haya existido un error al enviarle los detalles de la transacción al correo electrónico. Puede revisar el detalle de sus compras y pedidos ';
            this.mensaje_error = '';
          } else {
            console.log(error.response.data);
            this.mensaje = '';
            //this.mensaje_error = error.response.data.details
            this.mensaje_error =
              'Estimado cliente le informamos que no contamos con stock del producto solicitado, es posible que recientemente se haya agotado.';
          }
        });
    },

    createAccount_erp(new_json_data) {
      console.log('Este json se enviará:' + JSON.stringify(new_json_data));

      axios({
        method: 'post',
        url: 'https://zonasegura.frutaromla.com/frutarom_apitv/api/cliente/registrar',
        data: new_json_data,
      })
        .then((response) => {
          console.log('Usuario registrado correctamente en ERP!');
        })
        .catch((error) => {
          //console.log("Surgio un error" + error.response.data.errorCode);
          this.mensaje_error = 'ATENCIÓN: Se presentó un error en el envio de información al ERP.';
        });
    },

    get_delivery_detail() {
      axios
        .get(config_settings.RESOURCE_SERVER_URL + '/GET/deliverys/' + this.id_delivery)
        .then((response) => {
          this.delivery_detail = response.data;
          console.log('DETALLE ' + JSON.stringify(this.delivery_detail));
          this.gen_delivery_cost = this.delivery_detail.delivery_cost;
          console.log('COSTO:' + this.gen_delivery_cost);
          this.analizeCart();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    analizeCart() {
      let actual_total = 0.0;
      //var delivery = this.delivery_detail.delivery_cost;
      this.general_allowed_sale = true;
      this.cartProducts.forEach((product, index) => {
        if (product.allowed_sale == false) {
          this.general_allowed_sale = false;
        }
        if (product.allowed_tpv == false) {
          this.general_allowed_tpv = false;
        }
        console.log('precio del delivery ' + this.gen_delivery_cost);
        var subtotal = (product.price_product / 1.18) * (product.qty * 1.18) * 100;
        subtotal = Math.round(subtotal) / 100.0;
        actual_total = actual_total + subtotal;
        //actual_total = actual_total ;
      });
      this.totalValue = Math.round((actual_total + this.gen_delivery_cost) * 100) / 100;
    },
  },

  created() {
    this.scroll_inicio();
    this.get_puser_data();
  },
};
</script>

<style lang="scss" src="./visa-final.scss"></style>
